import { TrendingUp, TrendingDown } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Props {
  label: string;
  value: string;
  delta?: { value: string; positive: boolean };
  className?: string;
}

export function KPICard({ label, value, delta, className }: Props) {
  return (
    <div className={cn('rounded-lg border border-border bg-bg-surface p-5 transition-colors hover:border-border-strong', className)}>
      <div className="mb-3 text-xs text-text-muted">{label}</div>
      <div className="mb-2 font-mono text-3xl font-medium tracking-tight tabular-nums">{value}</div>
      {delta && (
        <div className={cn('inline-flex items-center gap-1 text-xs font-semibold', delta.positive ? 'text-success' : 'text-danger')}>
          {delta.positive ? <TrendingUp className="size-3" /> : <TrendingDown className="size-3" />}
          {delta.value}
        </div>
      )}
    </div>
  );
}
